import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import "./Greeting.css";

export const GREETING_SHOWN_KEY = "home.greeting.shown";

export function Greeting() {
  const { t } = useTranslation();
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(GREETING_SHOWN_KEY) !== "true") {
      sessionStorage.setItem(GREETING_SHOWN_KEY, "true");
      setShouldShow(true);
    }
  }, []);

  if (!shouldShow) {
    return null;
  }

  return (
    <h1 className="greeting" data-testid="greeting">
      <span className="greeting__text">{t("home.greeting.hello")}</span>
      <span className="greeting__icon" role="img">
        {"\u{1F44B}"}
      </span>
    </h1>
  );
}
